export default "__VITE_ASSET__Cg69npzt__"